module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09K281YYR.481942fe.jpg";